import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors} from '@angular/forms';

import {Subject} from 'rxjs';

import {CoreConfigService} from '@core/services/config.service';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {AuthenticationService} from '../../../../core/service';
import {TranslatePipe} from '@ngx-translate/core';
import {CoreTranslationService} from '../../../../../@core/services/translation.service';
import {ResetRequest} from '../../../../core/requests/ResetRequest';
import {confirmPassword, createPasswordStrengthValidator} from '../../../../core/helpers/custom-validators';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    TranslatePipe
  ],
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  // Public
  public coreConfig: any;
  public resetPasswordForm: FormGroup | null = null;
  public passwordTextType: boolean = false;
  public token: string;
  public userBase64Email: string;

  private ngUnsubscribe = new Subject();

  constructor(
    private _coreConfigService: CoreConfigService,
    private _formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _coreTranslationService: CoreTranslationService,
    private translate: TranslatePipe,
    private _toastrService: ToastrService
  ) {
    // this._coreTranslationService.translate(english, romanian);
    this.token = this._route.snapshot.params.resetToken || '';
    this.userBase64Email = this._route.snapshot.queryParamMap.get('user');
    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
      }
    };
  }

  ngOnInit(): void {
    this.resetPasswordForm = this._formBuilder.group({
      password: ['', [Validators.required, (control: AbstractControl) => {
        return createPasswordStrengthValidator(control, atob(this.userBase64Email))
      }]],
      confirmPassword: ['', [Validators.required]]
    },
    {
      validators: [confirmPassword('password', 'confirmPassword')]
    });

    // Subscribe to config changes
    this._coreConfigService.config.subscribe(config => {
      this.coreConfig = config;
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
  }

  get f(): { [key: string]: AbstractControl } {
    return this.resetPasswordForm.controls;
  }

  /**
     * Toggle password
     */
  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

  /**
     * Reset password
     */
  resetPassword() {

    const params: ResetRequest = {
      base64EncodedEmail: this.userBase64Email,
      password: this.f.password.value,
      token: decodeURIComponent(this.token)
    };

    this.authenticationService.resetPassword(params)
      .subscribe(
        _ => {
          this.onResetPasswordSuccess();
        },
        error => {
          this.onResetPasswordFail(error);
        });
  }

  public onResetPasswordSuccess() {
    this._toastrService.success(
      this.translate.transform('RESET_PASSWORD.SUCCESS'),
      this.translate.transform('SUCCESS'),
      {toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000}
    );
    // redirect to login
    setTimeout(() => {
      this._router.navigate(['/' + this._route.snapshot.params['subdomain'] + '/authentication/login']);
    }, 100);
  }

  public onResetPasswordFail(error: HttpErrorResponse) {
    this._toastrService.error(
      this.translate.transform('RESET_PASSWORD.FAIL'),
      this.translate.transform('ERROR'),
      {toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000}
    );
  }

  public getFormValidationErrors() {

    let totalErrors = 0;

    Object.keys(this.resetPasswordForm.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.resetPasswordForm.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
      }
    });
  }

}
